import axios from "axios";

const newRequest = axios.create({
  // baseURL: "http://localhost:8800/api/", //Mode Dev
  baseURL: "https://fiverr-api-kv1i.onrender.com/api/", //Mode Production
  withCredentials: true,
});

export default newRequest;
